export function invertAngle(angle: number) {
  if (angle === 0) {
    return 0;
  }
  return angle > 0 ? 360 - angle : -360 - angle;
}
